import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Button, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import InputBase from "@mui/material/InputBase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataDisplay from "../E-CertificateComponent/dataDisplay";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import { handleGenerateTestimonial, handleTestimonialLoading } from "../Redux/Certificate";
import { fetchCampaignsData, handleCampainIDSelection, resetSubmissionButton } from "../Redux/Mailer";
import "./testimonialForm.css";
const WhiteBorderTextField = styled(TextField)(({
  theme
}) => ({
  " & label.Mui-focused": {
    color: " #a804ff"
  },
  " & .MuiOutlinedInput-root": {
    padding: "8.5px 12px  !important",
    "&.Mui-focused fieldset": {
      borderColor: "#a814ff",
      borderWidth: "1px"
    }
  },
  "& .MuiInputBase-input": {
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"],
    fontSize: "14px"
  },
  "& .MuiInputBase-root-MuiOutlinedInput-root": {
    padding: "1px 2px !important"
  }
}));
const CustomRadio = styled(Radio)(({
  theme
}) => ({
  "&.Mui-checked": {
    color: "#9c27b0" // Purple for the checked state
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.5rem" // Custom icon size
  },
  "&:hover": {
    backgroundColor: "rgba(156, 39, 176, 0.08)" // Optional hover effect
  }
}));
const BootstrapInput = styled(InputBase)(({
  theme
}) => ({
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 14,
    padding: "9px 26px 9px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"]
  }
}));
const TestimonialForm = ({
  campaigns,
  mailerChild,
  setMailerChild,
  setMailerParent,
  mailerParent
}) => {
  const HtmlTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));
  const [programName, setprogramName] = useState("");
  const [campaign, setCampaign] = useState(0);
  const campaignList = useSelector(state => state.model.campaignList);
  const options = campaignList.message !== "No campaign for this user." && campaignList.length > 0 ? campaignList.map(item => ({
    id: item.id,
    name: item.name
  })) : [];
  const [categoryTestimonial, setCategoryTestimonial] = useState(-1);
  const [targetAudience, setTargetAudience] = useState("");
  const [message, setMessage] = useState("");
  const [isMailGenerated, setIsMailGenerated] = useState("init");
  const [inputTestimonial, setInputTestimonial] = useState("");
  const [isMailGenerationClicked, setIsGenerationClicked] = React.useState(false);
  const [isNavigatedToForm, setIsNavigatedToForm] = useState(false);
  const handleRadioChange = e => {
    setCategoryName(e.target.value);
    setValue("");
    handleRadioChangeReset();
    dispatch(fetchCampaignsData(e.target.value));
  };
  const [categoryName, setCategoryName] = useState("Program");
  const dispatch = useDispatch();
  const handleCategory = event => {
    setCategoryTestimonial(event.target.value);
    setIsMailGenerated("init");
  };
  const programCategories = ["Refine existing testimonial", " Create a new testimonial "];
  const handleCertificateMailGeneration = () => {
    setIsGenerationClicked(true);
    let values = {
      programName: programName,
      inputTestimonial: inputTestimonial,
      currentContent: "",
      sessionID: localStorage.getItem("sessionId"),
      categoryNameTestimonial: categoryTestimonial,
      categoryName: categoryName,
      message: message,
      targetAudience: targetAudience
    };
    dispatch(handleGenerateTestimonial(values));
  };
  const handleReset = () => {
    dispatch(resetSubmissionButton());
    dispatch(handleCampainIDSelection(0, null));
    setMailerChild("");
    setMailerParent("");
    setCategoryName("Program");
    setCategoryTestimonial("");
    setInputTestimonial();
    setMessage("");
    setTargetAudience("");
  };
  const handleCampaignID = val => {
    if (val) {
      setCampaign(val.id);
      let campaignID = val.id;
      dispatch(handleCampainIDSelection(campaignID));
      let data = campaignList.filter(val => val.id == campaignID);
      setprogramName(data[0].name);
    }
  };
  const [value, setValue] = React.useState(null);
  const handleChange = event => {
    if (event.target.value == "no") {
      setCampaign(0);
      dispatch(handleCampainIDSelection(0));
    }
    handleRadioChangeReset();
    setValue(event.target.value);
  };
  useEffect(() => {
    dispatch(fetchCampaignsData(categoryName));
  }, []);
  const handleRadioChangeReset = () => {
    setIsNavigatedToForm(false);
    setIsMailGenerated("init");
    dispatch(resetSubmissionButton());
    setCampaign(0);
    setCategoryTestimonial("");
    setInputTestimonial();
    setprogramName("");
    setMessage("");
    setTargetAudience("");
  };
  return <>
   {!isMailGenerationClicked ? <Stack sx={{
      width: "100%"
    }} spacing={10}>
     <Stack sx={{
        height: "20px"
      }}>
      <WelcomeNameContainer currentComp="Testimonials" />
     </Stack>
     <Stack spacing={4} sx={{
        paddingLeft: "30px",
        marginTop: "60px !important"
      }}>
      <div className="mailer-form-categories-section">
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Learning Program</span>
        <input type="radio" checked={categoryName === "Program"} value="Program" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Event</span>
        <input type="radio" checked={categoryName === "Event"} value="Event" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Microsite/Tool/Platform</span>
        <input type="radio" checked={categoryName === "Microsite/Tool/Platform"} value="Microsite/Tool/Platform" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>

       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Webinar</span>
        <input type="radio" checked={categoryName === "Webinar"} value="Webinar" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
      </div>
      <Stack direction={"row"} sx={{
          alignItems: "flex-start"
        }} spacing={2}>
       <Stack direction={"row"} sx={{
            alignItems: "flex-start"
          }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this communication part of any campaign?
          <span className="migrated-style-testimonialform-5cd7e1-1">*</span>
         </Typography>
         <Typography>(If yes, select the campaign name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={handleChange} sx={{
                paddingLeft: "20px"
              }}>
          <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-testimonialform-5cd7e1-2" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-testimonialform-5cd7e1-3" />} // Checkmark inside circle when checked
                />} label="Yes" />
          <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-testimonialform-5cd7e1-4" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-testimonialform-5cd7e1-5" />} // Checkmark inside circle when checked
                />} label="No" />
         </RadioGroup>
        </FormControl>
       </Stack>
       {value == "yes" && <Stack direction={"row"} sx={{
            alignItems: "center"
          }} spacing={2}>
         <Typography>
          Select the campaign <span className="migrated-style-testimonialform-5cd7e1-6">*</span>
         </Typography>
         <Stack sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginBottom: "10px",
              //  m: 1,
              width: 200
              //  mt: 3,
            }} direction={"row"} spacing={2}>
          {/* <Select value={campaign} onChange={handleCampaignID}>
           {campaignList.message != "No campaign for this user." &&
            campaignList.length > 0 &&
            campaignList.map((item, index) => (
             <MenuItem key={index + 1} value={item.id}>
              {item.name}
             </MenuItem>
            ))}
           </Select> */}
          <Autocomplete value={options.find(option => option.id === campaign) || null} onChange={(event, newValue) => {
                handleCampaignID(newValue);
              }} options={options} getOptionLabel={option => option.name || ""} ListboxProps={{
                style: {
                  maxHeight: "150px",
                  // Fixed height for the dropdown
                  overflowY: "auto" // Enable vertical scrolling
                }
              }} renderInput={params => <TextField sx={{
                "& .MuiOutlinedInput-root": {
                  padding: "2px !important"
                }
              }} {...params} variant="outlined" />} filterSelectedOptions={false} />
         </Stack>
        </Stack>}
      </Stack>
      <Stack direction={"column"} spacing={2} alignItems={"center"}>
       <Grid container spacing={2}>
        <Grid item xs={3}>
         <Stack spacing={0.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
           <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
            Name<span className="migrated-style-testimonialform-5cd7e1-7">*</span>
           </Typography>
           <HtmlTooltip arrow title={<React.Fragment>
              {" "}
              {categoryName == "program" ? <p> Enter the program name </p> : categoryName == "event" ? <p> Enter the event name</p> : categoryName == "Microsite/Tool/Platform" ? <p> Enter the Microsite/Tool/Platform name</p> : <p> Enter the Webinar name</p>}
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-testimonialform-5cd7e1-8"></img>
           </HtmlTooltip>
          </Stack>
          <WhiteBorderTextField placeholder={categoryName == "program" ? "e.g: Java Full Stack" : categoryName == "event" ? "e.g: Google Cloud Fusion Fest" : categoryName == "webinars" ? "e.g: Azure Open AI Security" : "e.g: HMM Spark"} id="multiline" multiline InputLabelProps={{
                  shrink: false
                }} minRows={1} disabled={value == null || value == "yes" && campaign == 0 ? true : false}
                //  maxRows={2}
                onChange={event => {
                  setprogramName(event.target.value);
                  setIsMailGenerated("init");
                }} InputProps={{
                  readOnly: value === "yes" && campaign != 0
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={programName} />
         </Stack>
        </Grid>
        <Grid item xs={3}>
         <Stack spacing={0.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
           <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
            Category<span className="migrated-style-testimonialform-5cd7e1-9">*</span>
           </Typography>
           <HtmlTooltip arrow title={<React.Fragment>Select category of testimonial </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-testimonialform-5cd7e1-10"></img>
           </HtmlTooltip>
          </Stack>
          <Stack sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  m: 1,
                  width: "200",
                  mt: 3
                }} direction={"row"} spacing={2}>
           <Select input={<BootstrapInput />} value={categoryTestimonial} onChange={handleCategory}
                  // MenuProps={MenuProps}
                  disabled={value == null || value == "yes" && campaign == 0 ? true : false}>
            {programCategories.map((item, index) => <MenuItem key={index + 1} value={index}>
              {item}
             </MenuItem>)}
           </Select>
          </Stack>
         </Stack>
        </Grid>
        {categoryTestimonial == 1 && <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Target Audience<span className="migrated-style-testimonialform-5cd7e1-11">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>
               <p> Specify Target audience </p>
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-testimonialform-5cd7e1-12"></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField placeholder="e.g: Leads/SME/peer/trainer/coach" id="multiline" multiline InputLabelProps={{
                  shrink: false
                }} minRows={1} disabled={value == null || value == "yes" && campaign == 0 ? true : false}
                //  maxRows={2}
                onChange={event => {
                  setTargetAudience(event.target.value);
                  setIsMailGenerated("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={targetAudience} />
          </Stack>
         </Grid>}
       </Grid>
       {categoryTestimonial == 0 ? <Grid container spacing={2}>
         <Grid item xs={6}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Testimonial<span className="migrated-style-testimonialform-5cd7e1-13">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>
               Provide existing testimonials of learners, SMEs, leads, etc.
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-testimonialform-5cd7e1-14"></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField placeholder={categoryName == "program" ? "e.g: I enjoyed my learning journey…" : categoryName == "event" ? "e.g: I thoroughly enjoyed the event… " : categoryName == "webinars" ? "e.g: I thoroughly enjoyed the webinar… " : "e.g: The tool/platform has helped me enhance my knowledge… "} id="outlined-multiline-flexible" multiline maxRows={7} minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} onChange={event => {
                  setInputTestimonial(event.target.value);
                  setIsMailGenerated("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={inputTestimonial} />
          </Stack>
         </Grid>
        </Grid> : <Grid container spacing={2}>
         <Grid item xs={6}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Message
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>Provide the message.</React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-testimonialform-5cd7e1-15"></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField placeholder={categoryName == "program" ? "e.g: I enjoyed my learning journey…" : categoryName == "event" ? "e.g: I thoroughly enjoyed the event… " : categoryName == "webinars" ? "e.g: I thoroughly enjoyed the webinar… " : "e.g: The tool/platform has helped me enhance my knowledge… "} id="outlined-multiline-flexible" multiline maxRows={7} minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} onChange={event => {
                  setMessage(event.target.value);
                  setIsMailGenerated("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={message} />
          </Stack>
         </Grid>
        </Grid>}

       <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={2}>
        {isNavigatedToForm && <Button sx={{
              border: "1px solid #d3d3d3",
              borderRadius: "5px",
              padding: "10px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              background: "#fff",
              color: "#a814ff",
              textTransform: "none",
              fontFamily: "Graphik-Medium"
            }} onClick={() => {
              setIsGenerationClicked(true);
              setIsMailGenerated("generateOutput");
            }}>
          Next
         </Button>}
        {programName == "" || categoryTestimonial == -1 || categoryTestimonial == 0 && inputTestimonial == "" || isMailGenerated !== "init" ? <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              pointerEvents: "none",
              opacity: " 0.4"
            }}>
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-testimonialform-5cd7e1-16"></img>
          <span className="migrated-style-testimonialform-5cd7e1-17">Generate</span>
         </Stack> : <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              cursor: "pointer"
            }} onClick={() => {
              handleCertificateMailGeneration();
              setIsMailGenerated("generateOutput");
              dispatch(handleTestimonialLoading());
            }}>
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-testimonialform-5cd7e1-18"></img>

          <span className="migrated-style-testimonialform-5cd7e1-19">Generate</span>
         </Stack>}
       </Stack>
      </Stack>
     </Stack>
    </Stack> : <DataDisplay mailerChild={mailerChild} mailerParent={mailerParent} programName={programName} categoryName={categoryName} handleReset={handleReset} setIsMailGenerated={setIsMailGenerated} setIsGenerationClicked={setIsGenerationClicked} setIsNavigatedToForm={setIsNavigatedToForm} />}
  </>;
};
export default TestimonialForm;
